import { useState, useRef, useEffect } from 'react';

const useSelfRemoveArray = (deletionDelay = 1000) => {
  const [array, updateArray] = useState([]);
  const timers = useRef([]);

  useEffect(() => {
    timers.current.forEach(clearTimeout);
    timers.current = [];
  }, []);

  const deleteItem = (id) => {
    updateArray((arr) => arr.filter((val) => val.id !== id));
  };

  const addItem = (item) => {
    const id = Date.now();
    const deletion = deletionDelay || 5000;
    updateArray((prevState) => prevState.slice(-2));
    updateArray((val) => [
      {
        id,
        item,
      },
      ...val,
    ]);

    if (deletion) {
      timers.current.push(
        setTimeout(() => {
          deleteItem(id);
        }, deletion)
      );
    }
  };

  return [array, addItem, deleteItem];
};

export default useSelfRemoveArray;
